import { ITask } from '../types/task';

const createTask = (res: any): ITask => {
  const { result_stat, output_file_url, source_file_url, result_data, ...rest } = res;
  return {
    ...rest,
    resultStat: result_stat,
    resultImage: output_file_url,
    sourceImage: source_file_url,
    detections: result_data?.detections,
  };
};

export default createTask;
